export function isSwatchOption($query) {
	return $query.filter('[data-option-is-swatch=true]')
}

export function notMaster($query) {
	return $query.filter('[data-option-is-master=false]')
}
